module.exports = __webpack_public_path__ + "static/media/work_face.e8485b36.png";